module.exports = __webpack_public_path__ + "static/media/director1.42d29f38.jpg";